import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styled from "styled-components"
import ZendeskDeveloperIcon from "../../images/zendesk.svg"

const StyledLink = styled(Link)`
  display: block;
  width: ${props => props.$width}px;
  text-decoration: none;

  &:focus {
    box-shadow: ${props => props.theme.focusBoxShadow};
  }
`

const LogoIcon = styled(ZendeskDeveloperIcon)`
  display: block;

  path,
  polygon {
    fill: ${props => props.theme.colors.header.logoColor};
  }
`

const LogoLink = ({ width }) => (
  <StyledLink to="/" $width={width} aria-label="Home">
    <LogoIcon aria-hidden="true" />
  </StyledLink>
)

LogoLink.propTypes = {
  width: PropTypes.number.isRequired
}

export default LogoLink
